import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Icon, type IconProps } from '@fv/client-components'

type InfoBoxProps = {
  children: ReactNode
  className?: string
  custom?: boolean
  icon?: IconProps['icon']
  iconProps?: Omit<IconProps, 'icon' | 'ref'>
  transform?: string
}

const InfoBox = ({
  children,
  className,
  custom = false,
  icon = 'hand-paper',
  iconProps,
}: InfoBoxProps) => {
  return (
    <div
      className={clsx(
        'boxed border border-fv-gray mb-4 bg-[repeating-linear-gradient(-45deg,#fff,#fff_10px,#f9f9f9_10px,#f9f9f9_20px)] p-4',
        !custom ? 'flex' : 'block',
        className,
        {
          custom,
        },
      )}
    >
      {custom && children}

      {!custom && (
        <>
          <Icon
            icon={icon}
            transform="down-3.5"
            className="text-fv-orange"
            {...iconProps}
          />
          <div className="leading-6 ml-2 flex-1">{children}</div>
        </>
      )}
    </div>
  )
}

export default InfoBox
